
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 20 20\" id=\"icon-success\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M10,0C4.477,0,0,4.477,0,10c0,5.523,4.477,10,10,10c5.521,0,10-4.477,10-10C20,4.477,15.521,0,10,0\r\n\t M15.892,7.122l-6.283,6.285l-1.062,1.062c-0.148,0.146-0.386,0.146-0.53,0l-1.061-1.062L4.11,10.559\r\n\tc-0.146-0.143-0.146-0.381,0-0.53l1.059-1.058c0.146-0.146,0.384-0.146,0.53,0l2.581,2.584l6.019-6.022\r\n\tc0.147-0.148,0.384-0.148,0.533,0l1.058,1.061C16.037,6.739,16.037,6.975,15.892,7.122\"/> </symbol>";
module.exports = sprite.add(image, "icon-success");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/success.svg
 ** module id = 232
 ** module chunks = 24
 **/